import Http from "./http";

export const getGrams = async () => {
  let data = await Http.get(`/instagram`);
  return data.data.slice(0,4);
};
